import {
	ROLE_STORE_MANAGER,
	ROLE_FRANCHISE_MANAGER,
	ROLE_SITE_ADMIN,
	ROLE_STORE_ADMIN,
	ROLE_MARKETING_ADMIN,
	ROLE_EVENT_ADMIN,
	ROLE_SUPER_ADMIN,
	ROLE_EXTERNAL_ADMIN,
	ROLE_COMPETITION_MANAGER,
	ROLE_FIELD_MANAGER,
	ROLE_TIMER_MANAGER,
} from 'shared/constant/lookup/role'

const storeManager = [
	{
		title: '프랜차이즈',
		items: [
			{
				name: '프랜차이즈 정보',
				path: '/manager/my',
			},
			{
				name: '본사 지급 내역',
				path: '/ticket',
			},
			{
				name: '매장 이용권 보유 현황',
				path: '/ticket-member',
			},
		],
	},
	{
		title: '매장',
		items: [
			{
				name: '내 매장 관리',
				path: '/store/my',
			},
			{
				name: '매장 대회 관리',
				path: '/event/my',
			},
		],
	},
]

const franchiseManager = [
	{
		title: '프랜차이즈 기본 설정',
		items: [
			{
				name: '프랜차이즈 정보 관리',
				path: '/manager/my',
			},
			{
				name: '프랜차이즈 매장 목록',
				path: '/list/store',
			},
			{
				name: '매장 이용권 관리',
				path: '/ticket-manager',
			},
			{
				name: '매장 이용권 보유 현황',
				path: '/ticket-member',
			},
			{
				name: '매장 이용권 사용 기록',
				path: '/store/my',
			},
		],
	},
	{
		title: '프랜차이즈 매장 관리',
		items: [
			{
				name: '내 매장 대회 관리',
				path: '/event/my',
			},
		],
	},
]

const siteAdmin = [
	{
		title: '대회',
		items: [
			{
				name: '대회 관리',
				path: '/event',
			},
		],
	},
]

const storeAdmin = [
	{
		title: '계정 관리',
		items: [
			{
				name: '매니저 관리',
				path: '/manager/franchise',
			},
		],
	},
]

const marketingAdmin = [
	{
		title: '칼럼',
		items: [
			{
				name: '공지사항 관리',
				path: '/notice',
			},
			{
				name: '광고 관리',
				path: '/ad',
			},
			{
				name: '유튜브 영상 관리',
				path: '/youtube',
			},
			{
				name: '미디어 관리',
				path: '/media',
			},
		],
	},
]

const eventAdmin = [
	{
		title: '계정 관리',
		items: [
			{
				name: '사용자 관리',
				path: '/user',
			},
		],
	},
	{
		title: '대회',
		items: [
			{
				name: '대회 시리즈 관리',
				path: '/series',
			},
			{
				name: '대회 관리',
				path: '/event',
			},
		],
	},
]

const superAdmin = [
	{
		title: '계정 관리',
		items: [
			{
				name: '사용자 관리',
				path: '/user',
			},
			{
				name: '관리자 관리',
				path: '/admin',
			},
			{
				name: '매니저 관리',
				path: '/manager/franchise',
			},
		],
	},
	{
		title: '대회',
		items: [
			{
				name: '대회 시리즈 관리',
				path: '/series',
			},
			{
				name: '대회 관리',
				path: '/event',
			},
		],
	},
	{
		title: '칼럼',
		items: [
			{
				name: '공지사항 관리',
				path: '/notice',
			},
			{
				name: '광고 관리',
				path: '/ad',
			},
			{
				name: '유튜브 영상 관리',
				path: '/youtube',
			},
			{
				name: '미디어 관리',
				path: '/media',
			},
		],
	},
	{
		title: '트라이아웃',
		items: [
			{
				name: '트라이아웃 필기 시험 관리',
				path: '/exam',
			},
			{
				name: '필기 결제 내역',
				path: '/wt-pay/list',
			},
			{
				name: '실기 결제 내역',
				path: '/pt-pay/list',
			},
		],
	},
	{
		title: '티켓 보유 현황',
		items: [
			{
				name: '시드권 현황',
				path: '/seed-ticket-status',
			},
			{
				name: '시드권 발급 기록',
				path: '/seed-ticket-log',
			},
			{
				name: '참가권 현황',
				path: '/join-ticket-status',
			},
		],
	},
	{
		title: '설정',
		items: [
			{
				name: '듀레이션 타이머 광고 관리',
				path: '/ad-timer',
			},
		],
	},
]

const externalAdmin = [
	{
		title: '계정 관리',
		items: [
			{
				name: '사용자 관리',
				path: '/user',
			},
		],
	},
	{
		title: '대회',
		items: [
			{
				name: '대회 시리즈 관리',
				path: '/series',
			},
			{
				name: '대회 관리',
				path: '/event',
			},
		],
	},
]

const competitionManager = [
	{
		title: '계정 관리',
		items: [
			{
				name: '사용자 관리',
				path: '/user',
			},
			{
				name: '매니저 관리',
				path: '/manager/sub-manager',
			},
			{
				name: '내 계정 관리',
				path: '/sub-manager/manage',
			},
		],
	},
	{
		title: '대회',
		items: [
			{
				name: '대회 시리즈 관리',
				path: '/series',
			},
			{
				name: '대회 관리',
				path: '/event',
			},
		],
	},

	{
		title: '트라이아웃',
		items: [
			{
				name: '트라이아웃 필기 시험 관리',
				path: '/exam/me',
			},
			{
				name: '필기 결제 내역',
				path: '/wt-pay/list',
			},
			{
				name: '실기 결제 내역',
				path: '/pt-pay/list',
			},
		],
	},
	{
		title: '티켓 보유 현황',
		items: [
			{
				name: '시드권 현황',
				path: '/seed-ticket-status',
			},
			{
				name: '시드권 발급 기록',
				path: '/seed-ticket-log',
			},
			{
				name: '참가권 현황',
				path: '/join-ticket-status',
			},
		],
	},
]

const registerManager = [
	{
		title: '계정 관리',
		items: [
			{
				name: '내 계정 관리',
				path: '/sub-manager/manage',
			},
		],
	},
	{
		title: '대회',
		items: [
			{
				name: '대회 관리',
				path: '/event',
			},
		],
	},
]

export default {
	[ROLE_STORE_MANAGER]: storeManager,
	[ROLE_FRANCHISE_MANAGER]: franchiseManager,
	[ROLE_SITE_ADMIN]: siteAdmin,
	[ROLE_STORE_ADMIN]: storeAdmin,
	[ROLE_MARKETING_ADMIN]: marketingAdmin,
	[ROLE_EVENT_ADMIN]: eventAdmin,
	[ROLE_SUPER_ADMIN]: superAdmin,
	[ROLE_EXTERNAL_ADMIN]: externalAdmin,
	[ROLE_COMPETITION_MANAGER]: competitionManager,
	[ROLE_FIELD_MANAGER]: registerManager,
	[ROLE_TIMER_MANAGER]: registerManager,
}
